export default __webpack_public_path__ + "tktyperegular.svg";